export default "__VITE_ASSET__DmzuX_q3__"